import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { DashboardConsultorResumo } from '@/types/dashboardConsultor';

interface DashboardConsultorResumoResponse {
  success: boolean;
  data: DashboardConsultorResumo;
}

export function useDashboardConsultorResumo() {
  return useQuery({
    queryKey: ['dashboard-consultor-resumo'],
    queryFn: async () => {
      const response = await api.get<DashboardConsultorResumoResponse>('/dashboard/consultor-resumo');
      return response.data;
    }
  });
}
